import { Tile } from '../../interfaces';

export const getTileSearchKey = (tile: Tile) => {
    return `${tile.x},${tile.y},${tile.z}`;
};
